import { render } from "./DemandForecastingRow.vue?vue&type=template&id=28ac77bf&scoped=true"
import script from "./DemandForecastingRow.vue?vue&type=script&lang=js"
export * from "./DemandForecastingRow.vue?vue&type=script&lang=js"

import "./DemandForecastingRow.vue?vue&type=style&index=0&id=28ac77bf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ac77bf"]])

export default __exports__